/**
 * Las CUATRO reglas de `Validation\PasswordPolicy` (servidor), del lado del cliente
 * (PKG-FORO-PASSWORD-SETTINGS-UX).
 *
 * Viven en su propio módulo porque ya las necesitan DOS pantallas —el Form A y el modal de
 * cambio de contraseña de Configuración— y una tercera las duplica a mano (la página `/reset`,
 * que no carga este bundle; ver la cabecera de `resources/views/core/reset-password.blade.php`).
 * Dos copias dentro del MISMO bundle sí serían una deriva evitable: por eso `registerForm`
 * importa de aquí en vez de declarar sus propias expresiones.
 *
 * Las propiedades Unicode son las mismas del servidor: «Ángela» tiene mayúscula y «ñ» es
 * minúscula, y una lista A-Z las dejaría fuera. Un dígito es `\p{Nd}`, que no está ni en
 * `\p{P}` ni en `\p{S}` — de ahí que un número no cuente como símbolo.
 */

/** En el orden en que se pintan en las listas de requisitos (mismo orden que `/reset`). */
export const PASSWORD_RULE_KEYS = ['length', 'upper', 'lower', 'symbol'] as const;

export type PasswordRuleKey = (typeof PASSWORD_RULE_KEYS)[number];

const UPPERCASE_RE = /\p{Lu}/u;
const LOWERCASE_RE = /\p{Ll}/u;
const SYMBOL_RE = /[\p{P}\p{S}]/u;

export const PASSWORD_RULES: Record<PasswordRuleKey, (value: string) => boolean> = {
  // `Array.from` cuenta puntos de código, no unidades UTF-16: un emoji vale 1, como en PHP.
  length: (value) => Array.from(value).length >= 8,
  upper: (value) => UPPERCASE_RE.test(value),
  lower: (value) => LOWERCASE_RE.test(value),
  symbol: (value) => SYMBOL_RE.test(value),
};

/** ¿Cumple `value` la política entera? El texto del «no» lo pone cada formulario. */
export function passwordMeetsPolicy(value: string): boolean {
  return PASSWORD_RULE_KEYS.every((key) => PASSWORD_RULES[key](value));
}
